/* eslint-disable camelcase */
import internetCopperRates, {
  internetFibreRates,
  telusOptikTvPricing,
  optikTvRatesMonthly,
  optikTvRatesThreeYears

} from './rates';
import request from '../../utils/request';

import {
  fieldStaticIPRequired,
  fieldQualifiedSpeed,
  fieldTerm,
  fieldTwoMonthsDuration,
  fieldRegularMonthlyOffers,
  fieldRegularYearlyOffers,
  fieldLimitedTimeOffer,
  fieldLimitedTimeBasicOffer,
  fieldLimitedYearlyOffersFibre150,
  fieldLimitedYearlyOffersFibre300,
  fieldLimitedTimeOfferYearly3g3000,
  fieldFiberInternetG1promo,
  fieldStaticIPRequiredFibre,
  fieldQualifiedSpeedFibre,
  fieldTermFibre,
  fieldRegularMonthlyOffersFibre,
  fieldRegularYearlyOffersFibre,
  fieldRegularYearlyOffersFibreBundled,
  fieldTwoMonthsFreeFibre,
  fieldLimitedMonthlyOfferFibre,
  fieldLimitedMonthlyOfferFibre75,
  fieldLimitedYearlyOffersFibre,
  fieldTelusOptikTvMonthlyRatePlan,
  fieldTelusOptikTvPricingAndOffers,
  fieldTelusOptikTvTwoMonthFree,
  numberTelusAccessPoints,
  fieldLimitedTimeOfferYearly15g,
  fieldLimitedMontlyOfferFibre3G,
  numberTelusWifiAccessPoints,
  telusPublicWifiFibre,
  fieldProductSelectionFibre,
  fieldTelusBusinessWifiOption,
  valueQualifiedSpeed940mbps,
  fieldInstallation,
  keySecureBusiness,
  fieldMobility,
  fieldBusinessConnect,
  fieldLimitedOfferFI,
  fieldFiberInternet75G1,
  fieldFibreInternet75G2,
  fieldFibreInternet75MPP,
  limitedYearlyOffersFibreBundled,
  limitedYearlyOffersFibreStandalone,
  valueFiberInternet,
  valueFibreInternet15GSwitchOffer,
  fieldStaticIpSubnet1,
  fieldStaticIpSubnet5,
  valueTerm60Month,
  fiveDollarsOff,
  fiveYearlyCopperPromos,
  fiveYearlyFibrePromos,
  valueTerm36Month,
  switchCredit$100,
  internetAndBusinessConnectBundleBillCredit200,
  billCredit100,
  contractBuyoutBillCredit300,
  contractBuyoutBillCredit600,
  fieldMppOffers,
  mppCrossSellOffer15,
  mppFibreInternet1G,
  valueQualifiedSpeed15gFibre,
  highSpeedFibreBillCredit,
  fieldLimitedYearlyOffersFibreFiveG,
  valueOptionFibreInternet5GPromo,
  optionHighSpeedBillCredit600,
  optionHighSpeedBillCredit800,
  optionHighSpeedBillCredit900,
  fieldTermBusinessTV,
  ab,
  alberta,
  britishColumbia,
  bc,
  twelveMonthPromoOptik,
  sixMonthPromoOptik,
  fieldStaticIpPromotion,
  staticIp1LabelPromotion,
  staticIp5LabelPromotion
} from '../../utils/constant';
import { getFieldOption, getFieldValue } from '../utils';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { getLocale } from '../../misc';

export const calculateOfficeCopperRates = (fields, localizedStrings) => {
  const {
    contentfulValues: {
      yes,
      yearsTerm,
      fiveYearsTerm,
      officeInternetBasicPromo,
      officeInternetEnhancedPromo,
      threeMonthsFree,
      // bundled,
      monthly,
      monthPromo,
      mbps100
    }
  } = localizedStrings;
  const locale = getLocale();

  const {
    WLS: { _valueTerm60Month, _bundled, _valueCopperStaticIpSubnet1, _valueCopperStaticIpSubnet5 }
  } = locale === 'en-US' ? EN : FR;
  let staticIPRate;
  let speedRate;
  let promoDiscount = 0;
  const valueStaticIP = getFieldValue(fieldStaticIPRequired, fields);
  const valueQualifiedSpeed = getFieldValue(fieldQualifiedSpeed, fields);
  const valueTerm = getFieldValue(fieldTerm, fields);
  const valueRegularMonthlyPromo = getFieldValue(
    fieldRegularMonthlyOffers,
    fields
  );
  const valueRegularYearlyPromo = getFieldValue(
    fieldRegularYearlyOffers,
    fields
  );
  const fiveYearlyPromosValue = getFieldValue(fiveYearlyCopperPromos, fields);
  const valueTwoMonthsPromo = getFieldValue(fieldTwoMonthsDuration, fields);
  const valueLimitedOffer = getFieldValue(fieldLimitedTimeOffer, fields);
  const valueLimitedBasicOffer = getFieldValue(
    fieldLimitedTimeBasicOffer,
    fields
  );

  const isPromotionIncluded = (limitedOffer, promotion) => {
    return (
      limitedOffer && limitedOffer.length && limitedOffer.includes(promotion)
    );
  };

  const isAnyFreePromoSelected =
    valueTwoMonthsPromo === yes ||
    isPromotionIncluded(valueLimitedOffer, threeMonthsFree) ||
    isPromotionIncluded(valueLimitedBasicOffer, threeMonthsFree);

  const {
    monthlyRates,
    yearlyRates,
    fiveYearlyRates,
    regularOffers: {
      monthPromo: regularMonthlyPromos,
      yearlyPromo: regularYearlyPromos
    },
    limitedBasicOffers,
    limitedEnhancedOffers
  } = internetCopperRates;

  if (valueStaticIP === _valueCopperStaticIpSubnet1) {
    staticIPRate = internetCopperRates[_valueCopperStaticIpSubnet1];
  } else if (valueStaticIP === _valueCopperStaticIpSubnet5) {
    staticIPRate = internetCopperRates[_valueCopperStaticIpSubnet5];
  }
  if (valueTerm === monthly) {
    if (valueQualifiedSpeed) {
      speedRate = monthlyRates[valueQualifiedSpeed];
      if (valueRegularMonthlyPromo === monthPromo && !isAnyFreePromoSelected) {
        promoDiscount += regularMonthlyPromos[valueQualifiedSpeed];
      }
      if (isAnyFreePromoSelected) {
        promoDiscount += monthlyRates[valueQualifiedSpeed];
      }
      if (
        (isPromotionIncluded(valueLimitedOffer, officeInternetBasicPromo) ||
          isPromotionIncluded(
            valueLimitedBasicOffer,
            officeInternetBasicPromo
          )) &&
        !isAnyFreePromoSelected
      ) {
        promoDiscount += limitedBasicOffers[valueQualifiedSpeed];
      }
      if (
        (isPromotionIncluded(valueLimitedOffer, officeInternetEnhancedPromo) ||
          isPromotionIncluded(
            valueLimitedBasicOffer,
            officeInternetEnhancedPromo
          )) &&
        !isAnyFreePromoSelected
      ) {
        promoDiscount += limitedEnhancedOffers[valueQualifiedSpeed];
      }
    }
  }
  if (valueTerm === yearsTerm || valueTerm === fiveYearsTerm) {
    const yearlyKey = valueTerm === yearsTerm ? yearlyRates : fiveYearlyRates;
    if (valueQualifiedSpeed) {
      speedRate = yearlyKey[valueQualifiedSpeed];
    }
    if (valueRegularYearlyPromo === _bundled) {
      promoDiscount += regularYearlyPromos[valueQualifiedSpeed];
    }
  }
  if (
    valueTerm === _valueTerm60Month &&
    fiveYearlyPromosValue === fiveDollarsOff
  ) {
    promoDiscount += 5;
  }
  staticIPRate = staticIPRate || 0;
  speedRate = speedRate || 0;
  promoDiscount = promoDiscount || 0;

  if (
    valueQualifiedSpeed === '100 / 20 Mbps' &&
    [yearsTerm, fiveYearsTerm].includes(valueTerm) &&
    valueRegularYearlyPromo === _bundled
  ) {
    return {
      addAmountToMonthly: staticIPRate + 55
    };
  }

  const addAmountToMonthly = staticIPRate + speedRate - promoDiscount;
  return {
    addAmountToMonthly
  };
};

export const calculateFibreRates = (fields, localizedStrings, orderData) => {
  const {
    contentfulValues: {
      yes,
      yearsTerm,
      threeMonthsFree,
      // bundled,
      monthly,
      monthPromo,
      standaloneOffer,
      valueThreeYearLtoPromo,
      valueFibreInternet15gPromo,
      mbps300,
      mbps150,
      mbps1G,
      mbps15G,
      mbps3G,
      mbps3G_3000
    }
  } = localizedStrings;
  const locale = getLocale();

  const validProvinces = [britishColumbia, alberta, ab, bc];
  validProvinces.includes(orderData.parsedProvince)

  const {
    WLS: {
      _valueTerm60Month,
      _billCredit100,
      _valueTerm36Month,
      _bundled,
      _valueFiveGSpeed,
      secureBusiness,
      mobility,
      businessConnect,
      telusBusinessWifi
    }
  } = locale === 'en-US' ? EN : FR;
  let staticIPRate;
  let speedRate;
  let promoDiscount = 0;
  let managerSpecialDiscount = 0;
  let staticIpdiscount = 0;

  const valueStaticIP = getFieldValue(fieldStaticIPRequiredFibre, fields);
  const valueQualifiedSpeed = getFieldValue(fieldQualifiedSpeedFibre, fields);
  const valueTerm = getFieldValue(fieldTermFibre, fields);
  const valueLimitedOfferFI = getFieldValue(fieldLimitedOfferFI, fields);

  const valueRegularMonthlyPromo = getFieldValue(
    fieldRegularMonthlyOffersFibre,
    fields
  );
  const valueRegularYearlyPromo = getFieldValue(
    fieldRegularYearlyOffersFibre,
    fields
  );
  const fiveYearlyPromosValue = getFieldValue(fiveYearlyFibrePromos, fields);
  const valueRegularYearlyPromoBundled = getFieldValue(
    fieldRegularYearlyOffersFibreBundled,
    fields
  );
  const valueTwoMonthsPromo = getFieldValue(fieldTwoMonthsFreeFibre, fields);
  const valueLimitedTimeOfferYearly15g = getFieldValue(
    fieldLimitedTimeOfferYearly15g,
    fields
  );
  const valueLimitedMonthlyOffer = getFieldValue(
    fieldLimitedMonthlyOfferFibre,
    fields
  );
  const valueLimitedMonthlyOffer75 = getFieldValue(
    fieldLimitedMonthlyOfferFibre75,
    fields
  );
  const valueLimitedYearlyOffer = getFieldValue(
    fieldLimitedYearlyOffersFibre,
    fields
  );

  const valueMppOffer = getFieldValue(fieldMppOffers, fields);

  const valueAccessPoints = getFieldValue(numberTelusAccessPoints, fields);
  const valueTelusWiFiAccessPoints = getFieldValue(
    numberTelusWifiAccessPoints,
    fields
  );
  const valueProductSelectionFibre = getFieldValue(
    fieldProductSelectionFibre,
    fields
  );
  const valueTelusPublicWifiFibre = getFieldValue(telusPublicWifiFibre, fields);
  const valueLimitedMonthlyOffer3 = getFieldValue(
    fieldLimitedMontlyOfferFibre3G,
    fields
  );
  const valueLimitedYearlyOffersFibre150 = getFieldValue(
    fieldLimitedYearlyOffersFibre150,
    fields
  );
  const valuelimitedYearlyOffersFibreAlbertaBC = getFieldValue(
    'limitedYearlyOffersFibreAlbertaBC',
    fields
  )
  const valuelimitedTimeOfferYearly15gAlbertaBC = getFieldValue(
    'limitedTimeOfferYearly15gAlbertaBC',
    fields
  )
  const valuelimitedTimeOfferYearly3g_3000AlbertaBC = getFieldValue(
    'limitedTimeOfferYearly3g_3000AlbertaBC',
    fields
  )
  const valueLimitedYearlyOffersFibre300 = getFieldValue(
    fieldLimitedYearlyOffersFibre300,
    fields
  );
  const valueLimitedTimeOfferYearly3g_3000 = getFieldValue(
    fieldLimitedTimeOfferYearly3g3000,
    fields
  );
  const valueLimitedMonthlyOfferFibre2_5G = getFieldValue(
    'limitedMonthlyOfferFibre2_5G',
    fields
  );
  const valueLimitedYearlyOffersFibreFiveG = getFieldValue(
    fieldLimitedYearlyOffersFibreFiveG,
    fields
  );
  const valueManagerSpecial = getFieldValue('fiberManagerSpecial', fields);
  const valueManagerSpecialAB = getFieldValue('fiberManagerSpecialAB', fields);

  const valueSwitchCreditPromo = getFieldValue(switchCredit$100, fields);
  const valueHighSpeedBillCredit = getFieldValue(
    highSpeedFibreBillCredit,
    fields
  );
  const valueStaticIPPromotion = getFieldValue(fieldStaticIpPromotion, fields);

  const isLimitedOfferSelected =
    valueLimitedMonthlyOffer ||
    valueLimitedMonthlyOffer75 ||
    valueLimitedMonthlyOffer3 ||
    valueLimitedYearlyOffer;

  const isAnyFreePromoSelected =
    [valueLimitedMonthlyOffer75, valueLimitedMonthlyOffer].includes(
      threeMonthsFree
    ) || valueTwoMonthsPromo === yes;
  const {
    monthlyRates,
    yearlyRates,
    yearlyRatesAlbertaBC,
    yearlyRatesBundleDiscountsForQuebec,
    yearlyRatesQuebec,
    yearlyRatesBundledWifiQuebec,
    yearlyRatesBundledForWifiQuebec,
    yearlyRatesBundleDiscountsQuebec,
    yearlyRatesStandaloneDiscountsForQuebec,
    yearlyRatesBundleDiscounts,
    billCredit100: billCredit100Rate,
    billCredit200,
    buyoutBillCredit300,
    buyoutBillCredit600,
    highSpeedBillCredit600,
    highSpeedBillCredit800,
    highSpeedBillCredit900,
    regularOffers: {
      monthPromo: regularMonthlyPromos,
      yearlyPromo: regularYearlyPromos,
      yearlyStandalonePromo,
      yearlyLimited3GPromo
    },
    limitedMonthlyOffers,
    limitedYearlyOffersFibre150,
    limitedYearlyOffersFibre300,
    limitedOfferFI,
    limitedYearlyOffersFibreBundled,
    limitedYearlyOffersFibreStandalone,
    threeYearBusinessWifiRates,
    fiveYearBusinessWifiRates,
    yearlyFibreMppDiscounts
  } = internetFibreRates;

  let accessPointsPrice = 0;
  let oneTimeTotal = 0;
  let threeYearLtoPromoDiscount = 0;
  let fibreInternet3gPromoDiscount = 0;
  let creditPromoDiscount = 0;

  const showAccessPoint = localStorage.getItem('showAccessPoint')
    ? localStorage.getItem('showAccessPoint')
    : null;

  if (valueTelusPublicWifiFibre !== yes) {
    if (valueAccessPoints) {
      accessPointsPrice =
        (valueAccessPoints - 1) * internetFibreRates.accessPointRate;
      if (valueAccessPoints) {
        oneTimeTotal = internetFibreRates.accessPointsOneTimeRate;
      }
    }
  } else {
    accessPointsPrice = 0;
    oneTimeTotal = 0;
  }

  if (valueLimitedTimeOfferYearly15g) {
    if (valueLimitedTimeOfferYearly15g === valueThreeYearLtoPromo) {
      threeYearLtoPromoDiscount += internetFibreRates.threeYearLtoPromoDiscount;
    }

    if (
      valueTerm === _valueTerm60Month &&
      valueLimitedTimeOfferYearly15g === valueFibreInternet15gPromo
    ) {
      threeYearLtoPromoDiscount +=
        internetFibreRates.fibreInternet15gPromoDiscount - 15;
    } else if (valueLimitedTimeOfferYearly15g === valueFibreInternet15gPromo) {
      threeYearLtoPromoDiscount +=
        internetFibreRates.fibreInternet15gPromoDiscount;
    }
  }

  /**
   * FOR FIBRE 3G/3000 MBPS
   * if Limited time promo Fibre Internet 3G Promo is selected
   * deduct $60 form either Standalone or Bundled
   */
  if (
    valueTerm === _valueTerm60Month &&
    valueLimitedTimeOfferYearly3g_3000 === 'Fibre Internet 3G promo'
  ) {
    fibreInternet3gPromoDiscount +=
      internetFibreRates.fibreInternet3gPromoDiscount - 20;
  } else if (valueLimitedTimeOfferYearly3g_3000 === 'Fibre Internet 3G promo') {
    fibreInternet3gPromoDiscount +=
      internetFibreRates.fibreInternet3gPromoDiscount;
  }

  if (
    valueLimitedTimeOfferYearly15g &&
    valueLimitedTimeOfferYearly15g === valueFibreInternet15GSwitchOffer
  ) {
    promoDiscount += internetFibreRates.fibre1_5GSwitchOffer;
  }

  if (
    valueLimitedYearlyOffersFibreFiveG &&
    valueLimitedYearlyOffersFibreFiveG === valueOptionFibreInternet5GPromo
  ) {
    promoDiscount += internetFibreRates.fibreInternet5gPromoDiscount;
  }

  //handle rate of (Fibre Internet 75 Limited Offers updates - CBM and MPP)on footer
  if (valueLimitedOfferFI) {
    promoDiscount += limitedOfferFI[valueLimitedOfferFI];
  }

  if (valueLimitedYearlyOffersFibre150) {
    promoDiscount +=
      limitedYearlyOffersFibre150[valueLimitedYearlyOffersFibre150];
  }

  if (
    (valueTerm === _valueTerm36Month || valueTerm === _valueTerm60Month) &&
    valueQualifiedSpeed &&
    valuelimitedYearlyOffersFibreAlbertaBC
  ) {
    promoDiscount += 10;
  }
  
  if (
    (valueTerm === _valueTerm36Month || valueTerm === _valueTerm60Month) &&
    valueQualifiedSpeed &&
    valuelimitedTimeOfferYearly15gAlbertaBC
  ) {
    if(valueTerm === _valueTerm60Month) promoDiscount += 20;
    if(valueTerm === _valueTerm36Month) promoDiscount += 15;
  }

  if (
    (valueTerm === _valueTerm36Month || valueTerm === _valueTerm60Month) &&
    valueQualifiedSpeed &&
    valuelimitedTimeOfferYearly3g_3000AlbertaBC
  ) {
    if(valueTerm === _valueTerm60Month) promoDiscount += 25;
    if(valueTerm === _valueTerm36Month) promoDiscount += 20;
  }

  if (valueLimitedYearlyOffersFibre300) {
    promoDiscount +=
      limitedYearlyOffersFibre300[valueLimitedYearlyOffersFibre300];
  }

  if (valueStaticIP === yes) {
    staticIPRate = internetFibreRates[fieldStaticIPRequired];
  } else if (valueStaticIP === fieldStaticIpSubnet1) {
    staticIPRate = internetFibreRates[fieldStaticIpSubnet1];
  } else if (valueStaticIP === fieldStaticIpSubnet5) {
    staticIPRate = internetFibreRates[fieldStaticIpSubnet5];
  }

  // const sixTwelveMonthPromoVa = getFieldValue()
  if (valueTerm === monthly) {
    if (valueQualifiedSpeed) {
      speedRate = monthlyRates[valueQualifiedSpeed];
      if (valueRegularMonthlyPromo === monthPromo && !isAnyFreePromoSelected) {
        promoDiscount += regularMonthlyPromos[valueQualifiedSpeed];
      }
      if (isAnyFreePromoSelected) {
        promoDiscount += monthlyRates[valueQualifiedSpeed];
      }
      if (isLimitedOfferSelected && !isAnyFreePromoSelected) {
        promoDiscount += limitedMonthlyOffers[valueQualifiedSpeed];
      }
    }
  }
  if (
    valueTerm === yearsTerm ||
    valueTerm === _valueTerm60Month ||
    valueTerm === _valueTerm36Month
  ) {
    if (valueQualifiedSpeed) {
      speedRate = yearlyRates[valueQualifiedSpeed];
    }

    if(valueRegularYearlyPromoBundled === _bundled && ['QC'].includes(request.getProvince())){
      if(![mbps150, mbps300, mbps1G].includes(valueQualifiedSpeed)){
        speedRate = yearlyRatesQuebec[valueQualifiedSpeed] - yearlyRatesBundleDiscountsQuebec[valueQualifiedSpeed];
      } else if([mbps150, mbps300, mbps1G].includes(valueQualifiedSpeed)){
        speedRate = yearlyRatesQuebec[valueQualifiedSpeed]
      }
    }

    if (valueQualifiedSpeed && validProvinces.includes(orderData.parsedProvince)) {
      speedRate = yearlyRatesAlbertaBC[valueTerm][valueQualifiedSpeed];
    }

    if (valueRegularYearlyPromoBundled === _bundled && valueProductSelectionFibre) {
      if(!validProvinces.includes(orderData.parsedProvince)){
      if (
        valueProductSelectionFibre &&
        valueProductSelectionFibre.includes('Telus Business Wi-Fi') &&
        valueProductSelectionFibre.includes('Mobility') &&
        !['QC'].includes(request.getProvince())
      ) {
        speedRate = yearlyRates[valueQualifiedSpeed];
      }else {
        speedRate =
        yearlyRates[valueQualifiedSpeed] -
        yearlyRatesBundleDiscounts[valueQualifiedSpeed];
      }

      if (request.getProvince() === 'QC') {
        if ([mbps150, mbps300, mbps1G].includes(valueQualifiedSpeed)) {
          if (valueProductSelectionFibre && valueProductSelectionFibre.includes('Telus Business Wi-Fi')) {
            // Filter out Telus Business Wi-Fi and count the remaining selected products
            const additionalSelectedProducts = valueProductSelectionFibre.filter(product =>
              [businessConnect, secureBusiness, mobility].includes(product)
            );
      
            if (additionalSelectedProducts.length > 0) {
              // Wi-Fi + one or two additional products
              speedRate =
                yearlyRatesQuebec[valueQualifiedSpeed] - 
                yearlyRatesBundledForWifiQuebec[valueQualifiedSpeed];
            } else if (valueProductSelectionFibre.length === 1) {
              // Wi-Fi only
              speedRate =
                yearlyRatesQuebec[valueQualifiedSpeed] -
                yearlyRatesBundledWifiQuebec[valueQualifiedSpeed];
            }
          } else if (
            valueProductSelectionFibre &&
            (
              valueProductSelectionFibre.includes(businessConnect) ||
              valueProductSelectionFibre.includes(secureBusiness) ||
              valueProductSelectionFibre.includes(mobility)
            )
          ) {
            // Only businessConnect, secureBusiness, or mobility without Wi-Fi
            speedRate = yearlyRatesQuebec[valueQualifiedSpeed] - 10;
          } else {
            // Default case with bundle discount
            speedRate =
              yearlyRatesQuebec[valueQualifiedSpeed] -
              yearlyRatesBundleDiscountsQuebec[valueQualifiedSpeed];
          }
        }
      }
     } else {
       if (valueProductSelectionFibre.includes(businessConnect)) {
         speedRate = speedRate - 10;
       } else if (valueProductSelectionFibre.includes(secureBusiness)) {
         speedRate = speedRate - 10;
       } else if (valueProductSelectionFibre.includes(mobility)) {
         speedRate = speedRate - 10;
       } else if (
         valueProductSelectionFibre.includes(telusBusinessWifi) &&
         (valueProductSelectionFibre.includes(secureBusiness) ||
           valueProductSelectionFibre.includes(businessConnect) ||
           valueProductSelectionFibre.includes(mobility))
       ) {
         speedRate = speedRate - 10;
       }
       if(valueProductSelectionFibre.includes(telusBusinessWifi)){
         speedRate = speedRate - 10;
       }
    }
    } else if (
      valueRegularYearlyPromoBundled === standaloneOffer &&
      ['QC'].includes(request.getProvince())
    ) {
      speedRate =
      yearlyRatesQuebec[valueQualifiedSpeed];
    }
    
    if (
      valueTerm === _valueTerm60Month &&
      fiveYearlyPromosValue === fiveDollarsOff
    ) {
      promoDiscount += 5;
    }

    if (
      valueTerm === _valueTerm60Month &&
      fiveYearlyPromosValue === fiveDollarsOff
    ) {
      promoDiscount += 5;
    }
    //  Fibre Internet 1G Limited Offers updates - CBM and MPP with bundled and stnadaloneOffer
    if (
      valueTerm === _valueTerm60Month &&
      valueLimitedYearlyOffer &&
      valueRegularYearlyPromoBundled === _bundled
    ) {
      promoDiscount +=
        limitedYearlyOffersFibreBundled[valueLimitedYearlyOffer] + 10;
    } else if (
      valueLimitedYearlyOffer &&
      valueRegularYearlyPromoBundled === _bundled
    ) {
      promoDiscount += limitedYearlyOffersFibreBundled[valueLimitedYearlyOffer];
    }
    if (
      valueTerm === _valueTerm60Month &&
      valueLimitedYearlyOffer &&
      valueRegularYearlyPromoBundled === standaloneOffer
    ) {
      promoDiscount +=
        limitedYearlyOffersFibreStandalone[valueLimitedYearlyOffer] + 10;
    } else if (
      valueLimitedYearlyOffer &&
      valueRegularYearlyPromoBundled === standaloneOffer
    ) {
      promoDiscount +=
        limitedYearlyOffersFibreStandalone[valueLimitedYearlyOffer];
    }

    if (valueLimitedMonthlyOffer3 && !isAnyFreePromoSelected) {
      promoDiscount += yearlyLimited3GPromo[valueLimitedMonthlyOffer3];
    }
  }

  if (
    valueProductSelectionFibre &&
    // valueProductSelectionFibre.includes(keySecureBusiness) ||
    // valueProductSelectionFibre.includes(fieldMobility) ||
    // valueProductSelectionFibre.includes(fieldBusinessConnect) ||
    valueProductSelectionFibre.includes(fieldTelusBusinessWifiOption) &&
    !validProvinces.includes(orderData.parsedProvince)
  ) {
    if (
      valueTerm === _valueTerm36Month &&
      valueQualifiedSpeed === valueQualifiedSpeed940mbps &&
      valueLimitedYearlyOffer === fieldFiberInternetG1promo
    ) {
      promoDiscount += 5;
    }
    if (valueTerm === _valueTerm36Month) {
      promoDiscount += threeYearBusinessWifiRates[valueQualifiedSpeed];
    }
    if (valueTerm === _valueTerm60Month) {
      promoDiscount += fiveYearBusinessWifiRates[valueQualifiedSpeed];
      if (valueProductSelectionFibre.includes('Mobility')) {
        if (valueQualifiedSpeed === valueQualifiedSpeed940mbps)
          promoDiscount += 10;
        if (valueQualifiedSpeed === valueQualifiedSpeed15gFibre)
          promoDiscount += 10;
        if (valueQualifiedSpeed === '3G/3000 mbps')
          fibreInternet3gPromoDiscount -= 75;
      }
    }
  }
  if (
    valueManagerSpecial === 'managerspecial$5' &&
    (valueTerm === _valueTerm60Month || valueTerm === _valueTerm36Month) &&
    [mbps1G, mbps15G, 'Fibre Internet 3G: 3G/3GMbps', '3G/3000 mbps', _valueFiveGSpeed].includes(
      valueQualifiedSpeed
    ) &&
    valueRegularYearlyPromoBundled &&
    !validProvinces.includes(orderData.parsedProvince)
  ) {
    if (
      valueRegularYearlyPromoBundled === _bundled &&
      valueProductSelectionFibre.includes('Telus Business Wi-Fi') &&
      !valueProductSelectionFibre.includes('Secure Business') &&
      !valueProductSelectionFibre.includes('Business Connect')
    ) {
      managerSpecialDiscount = 5;
    } else if (valueRegularYearlyPromoBundled === standaloneOffer) {
      managerSpecialDiscount = 5;
    }
  }

  if (
    valueManagerSpecial === 'managerspecial$5' &&
    (valueTerm === _valueTerm60Month || valueTerm === _valueTerm36Month) &&
    [mbps300].includes(
      valueQualifiedSpeed
    ) &&
    valueRegularYearlyPromoBundled
  ) {
    if (
      valueRegularYearlyPromoBundled === _bundled
    ) {
      managerSpecialDiscount = 5;
    } else if (valueRegularYearlyPromoBundled === standaloneOffer) {
      managerSpecialDiscount = 5;
    }
  }

  if (
    valueManagerSpecial === 'managerspecial$5' &&
    (valueTerm === _valueTerm60Month || valueTerm === _valueTerm36Month) &&
    valueQualifiedSpeed === mbps1G &&
    valueRegularYearlyPromoBundled &&
    ['QC'].includes(request.getProvince())
  ) {
    if (
      valueRegularYearlyPromoBundled === _bundled &&
      valueProductSelectionFibre.includes('Mobility')
    ) {
      managerSpecialDiscount = 5;
    }
  }

  if (
    valueManagerSpecial === 'managerspecial$5' &&
    (valueTerm === _valueTerm60Month || valueTerm === _valueTerm36Month) &&
    [mbps1G, mbps15G, 'Fibre Internet 3G: 3G/3GMbps', '3G/3000 mbps', _valueFiveGSpeed].includes(
      valueQualifiedSpeed
    ) &&
    valueRegularYearlyPromoBundled &&
    validProvinces.includes(orderData.parsedProvince)
  ) {
    if (
      valueRegularYearlyPromoBundled === _bundled &&
      valueProductSelectionFibre.includes('Mobility')
    ) {
      promoDiscount += 5;
    } else if (valueRegularYearlyPromoBundled === standaloneOffer) {
      promoDiscount += 5;
    }
  }

  if (
    valueManagerSpecialAB === 'managerspecial$5' &&
    (valueTerm === _valueTerm60Month || valueTerm === _valueTerm36Month) &&
    [mbps1G, mbps15G, 'Fibre Internet 3G: 3G/3GMbps', '3G/3000 mbps', _valueFiveGSpeed, mbps300].includes(
      valueQualifiedSpeed
    ) &&
    valueRegularYearlyPromoBundled &&
    validProvinces.includes(orderData.parsedProvince)
  ) {
    if (
      valueRegularYearlyPromoBundled === _bundled
    ) {
      promoDiscount += 5;
    }
  }

  if (
    valueSwitchCreditPromo === internetAndBusinessConnectBundleBillCredit200
  ) {
    creditPromoDiscount += billCredit200;
  }
  if (valueSwitchCreditPromo === contractBuyoutBillCredit300) {
    creditPromoDiscount += buyoutBillCredit300;
  }
  if (valueSwitchCreditPromo === contractBuyoutBillCredit600) {
    creditPromoDiscount += buyoutBillCredit600;
  }

  if (valueSwitchCreditPromo === _billCredit100) {
    creditPromoDiscount += billCredit100Rate;
  }

  // SOF-2373 Hiding Bill Credits for now, uncomment and add from Contentful to make it work
  //
  // Rates for High speed Fibre Bill Credit
  // if (valueHighSpeedBillCredit === optionHighSpeedBillCredit600) {
  //   creditPromoDiscount += highSpeedBillCredit600;
  // }
  // if (valueHighSpeedBillCredit === optionHighSpeedBillCredit800) {
  //   creditPromoDiscount += highSpeedBillCredit800;
  // }

  // if (valueHighSpeedBillCredit === optionHighSpeedBillCredit900) {
  //   creditPromoDiscount += highSpeedBillCredit900;
  // }

  staticIPRate = staticIPRate || 0;
  speedRate = speedRate || 0;
  promoDiscount = promoDiscount || 0;

  if (valueMppOffer === mppCrossSellOffer15) {
    staticIPRate -= yearlyFibreMppDiscounts.crossSellOffer15;
  }

  if (valueMppOffer === mppFibreInternet1G) {
    staticIPRate -= yearlyFibreMppDiscounts.mppFibreInternet1G;
  }

  if (
    valueTerm === yearsTerm &&
    [
      mbps300,
      mbps1G,
      mbps15G,
      'Fibre Internet 3G: 3G/3GMbps',
      '3G/3000 mbps',
      _valueFiveGSpeed
    ].includes(valueQualifiedSpeed) &&
    valueRegularYearlyPromoBundled === _bundled &&
    valueProductSelectionFibre &&
    valueProductSelectionFibre.includes('Telus Business Wi-Fi')
  ) {
    if (valueQualifiedSpeed === mbps300 && valueLimitedYearlyOffersFibre300) {
      return {
        addAmountToMonthly: staticIPRate + 70,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    // Urgent new pricing for black friday sof-2290
    if (
      valueQualifiedSpeed === mbps300 &&
      valueTerm === _valueTerm36Month &&
      valueProductSelectionFibre.length === 1 && 
      !['QC'].includes(request.getProvince()) && 
      !validProvinces.includes(orderData.parsedProvince)
    ) {
      return {
        addAmountToMonthly: staticIPRate + 65,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }
    if (
      valueQualifiedSpeed === mbps1G &&
      valueTerm === _valueTerm36Month &&
      !valueProductSelectionFibre.includes('Mobility') &&
      // valueProductSelectionFibre.length === 1 &&
      valueLimitedYearlyOffer === fieldFiberInternetG1promo
    ) {
      return {
        addAmountToMonthly: staticIPRate + 90 - managerSpecialDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }
    if (
      valueQualifiedSpeed === mbps15G &&
      valueTerm === _valueTerm36Month &&
      !valueProductSelectionFibre.includes('Mobility') &&
      // valueProductSelectionFibre.length === 1 &&
      valueLimitedTimeOfferYearly15g
    ) {
      return {
        addAmountToMonthly: staticIPRate + 100 - managerSpecialDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }
    if (
      valueQualifiedSpeed === '3G/3000 mbps' &&
      valueTerm === _valueTerm36Month &&
      !valueProductSelectionFibre.includes('Mobility') &&
      // valueProductSelectionFibre.length === 1 &&
      valueLimitedTimeOfferYearly3g_3000
    ) {
      return {
        addAmountToMonthly: staticIPRate + 105 - managerSpecialDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    // Bundled + Mobility + TELUS Business Wifi + Fibre Internet 1G promo
    if (
      valueQualifiedSpeed === mbps1G &&
      valueLimitedYearlyOffer &&
      valueProductSelectionFibre.includes('Mobility')
    ) {
      return {
        addAmountToMonthly: staticIPRate + 80 - managerSpecialDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    if (valueQualifiedSpeed === mbps1G && valueLimitedYearlyOffer) {
      return {
        addAmountToMonthly: staticIPRate + 85,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    // Bundled + Mobility + TELUS Business Wifi + Fibre Internet 1.5G promo
    if (
      valueQualifiedSpeed === mbps15G &&
      valueLimitedTimeOfferYearly15g &&
      valueProductSelectionFibre.includes('Mobility') &&
      valueTerm === _valueTerm36Month
    ) {
      return {
        addAmountToMonthly: staticIPRate + 90 - managerSpecialDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    if (valueQualifiedSpeed === mbps15G && valueLimitedTimeOfferYearly15g) {
      return {
        addAmountToMonthly: staticIPRate + 105,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    if (
      valueQualifiedSpeed === 'Fibre Internet 3G: 3G/3GMbps' &&
      valueLimitedMonthlyOfferFibre2_5G
    ) {
      return {
        addAmountToMonthly: staticIPRate + 115,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    // Bundled + Mobility + TELUS Business Wifi + Fibre Internet 3G promo
    if (
      valueQualifiedSpeed === '3G/3000 mbps' &&
      valueLimitedTimeOfferYearly3g_3000 &&
      valueProductSelectionFibre.includes('Mobility')
    ) {
      return {
        addAmountToMonthly: staticIPRate + 95 - managerSpecialDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }
    // Black Friday Promotion
    if (
      valueQualifiedSpeed === '3G/3000 mbps' &&
      valueLimitedTimeOfferYearly3g_3000 === '3 Months Free'
    ) {
      promoDiscount = 10;
      return {
        addAmountToMonthly: staticIPRate + 115 - promoDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    if (
      valueQualifiedSpeed === '3G/3000 mbps' &&
      valueLimitedTimeOfferYearly3g_3000
    ) {
      return {
        addAmountToMonthly: staticIPRate + 115,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }
  } else if (
    valueTerm === _valueTerm60Month &&
    [
      mbps300,
      mbps1G,
      mbps15G,
      'Fibre Internet 3G: 3G/3GMbps',
      '3G/3000 mbps'
    ].includes(valueQualifiedSpeed) &&
    valueRegularYearlyPromoBundled === _bundled &&
    valueProductSelectionFibre &&
    valueProductSelectionFibre.includes('Telus Business Wi-Fi')
  ) {
    // sof-2377 changes for only 60 month term
    if (valueQualifiedSpeed === mbps300 && valueLimitedYearlyOffersFibre300) {
      return {
        addAmountToMonthly: staticIPRate + 70,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }
    // Urgent new pricing for black friday sof-2290
    if (
      valueQualifiedSpeed === mbps300 &&
      valueTerm === _valueTerm36Month &&
      valueProductSelectionFibre.length === 1 &&
      !validProvinces.includes(orderData.parsedProvince)
    ) {
      return {
        addAmountToMonthly: staticIPRate + 65,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }
    if (
      valueQualifiedSpeed === mbps1G &&
      valueTerm === _valueTerm60Month &&
      !valueProductSelectionFibre.includes('Mobility') &&
      // valueProductSelectionFibre.length === 1 &&
      valueLimitedYearlyOffer === fieldFiberInternetG1promo
    ) {
      return {
        addAmountToMonthly: staticIPRate + 80 - managerSpecialDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }
    if (
      valueQualifiedSpeed === mbps15G &&
      valueTerm === _valueTerm60Month &&
      !valueProductSelectionFibre.includes('Mobility') &&
      // valueProductSelectionFibre.length === 1 &&
      valueLimitedTimeOfferYearly15g
    ) {
      return {
        addAmountToMonthly: staticIPRate + 85 - managerSpecialDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }
    if (
      valueQualifiedSpeed === '3G/3000 mbps' &&
      valueTerm === _valueTerm60Month &&
      !valueProductSelectionFibre.includes('Mobility') &&
      // valueProductSelectionFibre.length === 1 &&
      valueLimitedTimeOfferYearly3g_3000
    ) {
      return {
        addAmountToMonthly: staticIPRate + 85 - managerSpecialDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    // Bundled + Mobility + TELUS Business Wifi + Fibre Internet 1G promo
    if (
      valueQualifiedSpeed === mbps1G &&
      valueLimitedYearlyOffer &&
      valueProductSelectionFibre.includes('Mobility')
    ) {
      return {
        addAmountToMonthly: staticIPRate + 70 - managerSpecialDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    if (valueQualifiedSpeed === mbps1G && valueLimitedYearlyOffer) {
      return {
        addAmountToMonthly: staticIPRate + 85,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    // Bundled + Mobility + TELUS Business Wifi + Fibre Internet 1.5G promo
    if (
      valueQualifiedSpeed === mbps15G &&
      valueLimitedTimeOfferYearly15g &&
      valueProductSelectionFibre.includes('Mobility') &&
      valueTerm === _valueTerm60Month
    ) {
      return {
        addAmountToMonthly: staticIPRate + 75 - managerSpecialDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    if (valueQualifiedSpeed === mbps15G && valueLimitedTimeOfferYearly15g) {
      return {
        addAmountToMonthly: staticIPRate + 105,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    if (
      valueQualifiedSpeed === 'Fibre Internet 3G: 3G/3GMbps' &&
      valueLimitedMonthlyOfferFibre2_5G
    ) {
      return {
        addAmountToMonthly: staticIPRate + 115,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    // Bundled + Mobility + TELUS Business Wifi + Fibre Internet 3G promo
    if (
      valueQualifiedSpeed === '3G/3000 mbps' &&
      valueLimitedTimeOfferYearly3g_3000 &&
      valueProductSelectionFibre.includes('Mobility')
    ) {
      return {
        addAmountToMonthly: staticIPRate + 75 - managerSpecialDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }
    // Black Friday Promotion
    if (
      valueQualifiedSpeed === '3G/3000 mbps' &&
      valueLimitedTimeOfferYearly3g_3000 === '3 Months Free'
    ) {
      promoDiscount = 10;
      return {
        addAmountToMonthly: staticIPRate + 115 - promoDiscount,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }

    if (
      valueQualifiedSpeed === '3G/3000 mbps' &&
      valueLimitedTimeOfferYearly3g_3000
    ) {
      return {
        addAmountToMonthly: staticIPRate + 115,
        addAmountToPrice: oneTimeTotal - creditPromoDiscount
      };
    }
  }

  if (valueStaticIPPromotion === staticIp5LabelPromotion) {
    staticIpdiscount = 20;
  } else if (valueStaticIPPromotion === staticIp1LabelPromotion) {
    staticIpdiscount = 12;
  }

  const addAmountToMonthly =
    staticIPRate +
    speedRate -
    promoDiscount +
    accessPointsPrice +
    threeYearLtoPromoDiscount +
    fibreInternet3gPromoDiscount -
    managerSpecialDiscount -
    staticIpdiscount;

  return {
    addAmountToMonthly,
    addAmountToPrice: oneTimeTotal - creditPromoDiscount
  };
};

export const calculateTelusOptikRates = (fields) => {
  const locale = getLocale();

  const {
    contentfulValues: {
      installationValues, _valueTerm36MonthBT, _valueTermMonthlyBT
    }  } = locale === 'en-US' ? EN : FR;

    let addAmountToPrice = 0; 
    let monthlyPlanRate = 0;
    let topBoxInitialRate = 0;
  const valueTermBusinessTV = getFieldValue(
    fieldTermBusinessTV,
    fields
  )
  const telusOptikTvMonthlyRatePlanValue = getFieldValue(
    fieldTelusOptikTvMonthlyRatePlan,
    fields
  );

  const installationValue = getFieldValue(fieldInstallation, fields);
  const { winBackNoPrice, topBoxesThreeYearTerm, topBoxesMonthlyTerm } = telusOptikTvPricing;

  if (
    valueTermBusinessTV === _valueTerm36MonthBT
  ) {
    if (telusOptikTvMonthlyRatePlanValue) {
      monthlyPlanRate = optikTvRatesThreeYears[telusOptikTvMonthlyRatePlanValue] || 0;
      topBoxInitialRate = topBoxesThreeYearTerm[telusOptikTvMonthlyRatePlanValue] || 0;
    }
  } else if (valueTermBusinessTV === _valueTermMonthlyBT){
    if (telusOptikTvMonthlyRatePlanValue) {
      monthlyPlanRate = optikTvRatesMonthly[telusOptikTvMonthlyRatePlanValue] || 0;
      topBoxInitialRate = topBoxesMonthlyTerm[telusOptikTvMonthlyRatePlanValue] || 0;
    }
  }

  if (
    [installationValues.professionalInstall].includes(installationValue)
  ) {
    addAmountToPrice += winBackNoPrice[installationValue];
  }
  
  const addAmountToMonthly = (monthlyPlanRate || 0) + (topBoxInitialRate || 0);

  return {
    addAmountToMonthly,
    addAmountToPrice
  };
};

